import React from 'react';
import { getSubCategoryId } from '../utils/DictionaryManagementUtils';
import EnterLoanAmountDF from '../components/SimulatorsComponents/DefualtSimulators/EnterLoanAmountDF';

//= ========================================================================
const Sim_J01_LoanUpdateAmount = ({
  globJSON,
  selectedScreen,
  simPlatform,
}) => (
  <EnterLoanAmountDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    amount={globJSON.configurations.services[getSubCategoryId(globJSON.screens[selectedScreen])].amount}
  />
);

export default Sim_J01_LoanUpdateAmount;
